import React from 'react';
import PropTypes from 'prop-types';

import Banner from './Banner';
import LockIcon from './LockIcon';

const getBannerText = (text, deprecated) => {
  if (text) {
    return text;
  }

  if (deprecated) {
    return 'This resource is out of date and can no longer be edited. Please consider copying any text you were working on before reloading the page.';
  }

  return 'This resource is currently read-only';
};

export const LockBanner = ({ text, deprecated, locked }) => (
  <Banner>
    {(locked || deprecated) && <LockIcon className="mr1" />}
    <div>{getBannerText(text, deprecated)}</div>
  </Banner>
);

LockBanner.defaultProps = {
  children: null,
  deprecated: false,
  locked: false,
};

LockBanner.propTypes = {
  children: PropTypes.node,
  deprecated: PropTypes.bool,
  locked: PropTypes.bool,
};
